export class PrymeSdkError extends Error {
    code;
    status;
    constructor(code, message, status) {
        super(message ?? code);
        this.code = code;
        this.status = status;
        this.name = 'PrymeSdkError';
    }
}
